<template>
  <base-jin-nang-table
    :titleList="titleList"
    v-on:row-clicked="repoClick"
    :dataList="dataList"
    @titleSort="titleSort"
  >
  </base-jin-nang-table>
</template>

<script>
import BaseJinNangTable from '../BaseJinNangTable'
export default {
  name: 'JinNangRepoTable',
  components: { BaseJinNangTable },
  props: {
    repoList: {
      type: Array,
      required: true
    },
    isRowPointer: {
      type: Boolean,
      require: true
    }
  },
  data() {
    return {
      titleList: [
        { text: '证券代码', class: '' },
        { text: '证券名称', class: '' },
        { text: '证券数量', class: '' },
        { text: '可卖数量', class: '' },
        { text: '成本价（元）', class: '' },
        { text: '现价（元）', class: '' },
        { text: '浮动盈亏', class: '', sort: { datakey: 'totalGailLoss' } },
        { text: '盈亏比例', class: '', sort: { datakey: 'gainLossScale' } },
        { text: '最新市值', class: '', sort: { datakey: 'marketValue' } },
        { text: '持仓比例', class: '', sort: { datakey: 'secuScale' } }
      ]
    }
  },
  computed: {
    currentJinNangId() {
      return this.$route.params.id
    },
    totalGailLoss() {
      if (this.repoList && this.repoList.length > 0) {
        return (
          this.repoList.reduce((a, b) => a.totalGailLoss + b.totalGailLoss) /
          10000
        )
      } else {
        return 0
      }
    },
    dataList() {
      if (this.repoList && this.repoList.length > 0) {
        return this.repoList.map(a => ({
          tr: a,
          tds: [
            {
              text: a.securitiesCode,
              class:
                this.getSymbolClass(a.totalGailLoss) +
                (this.isRowPointer ? ' pointer' : '')
            },
            {
              text: a.securitiesName,
              class:
                this.getSymbolClass(a.totalGailLoss) +
                (this.isRowPointer ? ' pointer' : '')
            },
            {
              text: a.secuAmuntStr,
              class:
                this.getSymbolClass(a.totalGailLoss) +
                (this.isRowPointer ? ' pointer' : '')
            },
            {
              text: a.usableAmountStr,
              class:
                this.getSymbolClass(a.totalGailLoss) +
                (this.isRowPointer ? ' pointer' : '')
            },
            {
              text: a.dilucostPriceStr,
              class:
                this.getSymbolClass(a.totalGailLoss) +
                (this.isRowPointer ? ' pointer' : '')
            },
            {
              text: a.newPriceStr,
              class:
                this.getSymbolClass(a.totalGailLoss) +
                (this.isRowPointer ? ' pointer' : '')
            },
            {
              text: (a.totalGailLoss / 10000).toFixed(2),
              class:
                this.getSymbolClass(a.totalGailLoss) +
                (this.isRowPointer ? ' pointer' : '')
            },
            {
              text: a.gainLossScale,
              class:
                this.getSymbolClass(a.totalGailLoss) +
                (this.isRowPointer ? ' pointer' : '')
            },
            {
              text: (a.marketValue / 10000).toFixed(2),
              class:
                this.getSymbolClass(a.totalGailLoss) +
                (this.isRowPointer ? ' pointer' : '')
            },
            {
              text: a.secuScale / 100 + '%',
              class:
                this.getSymbolClass(a.totalGailLoss) +
                (this.isRowPointer ? ' pointer' : '')
            }
          ]
        }))
      } else {
        return []
      }
    }
  },
  methods: {
    getSymbol(number) {
      const dig = parseFloat(number)
      return dig
    },
    getSymbolClass(number) {
      var symblo = this.getSymbol(number)
      if (symblo > 0) {
        return 'c1'
      } else if (symblo < 0) {
        return 'c3'
      } else {
        return ''
      }
    },
    toPercent(point) {
      var str = Number(point * 100).toFixed(1)
      str += '%'
      return str
    },
    repoClick(item) {
      this.$emit('repo-selected', item)
    },
    titleSort(item) {
      if (item.sort.datakey && item.sort.direction) {
        this.repoList.sort((a, b) => {
          if (item.sort.direction === -1) {
            return (
              parseFloat(b[item.sort.datakey]) -
              parseFloat(a[item.sort.datakey])
            )
          } else {
            return (
              parseFloat(a[item.sort.datakey]) -
              parseFloat(b[item.sort.datakey])
            )
          }
        })
      }
    }
  }
}
</script>
